module.exports = __webpack_public_path__ + "static/izi-logo-rounded-text-white-3293aec23ad62f1ae450afad4300f752.svg";